import React from 'react';
import { MoreHorizontalIcon, ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface NewsletterItem {
  id: string;
  title: string;
  template: string;
  sentDate: string;
  recipients: number;
  status: 'draft' | 'scheduled' | 'sent' | 'failed';
}
interface RecentNewsletterCardProps {
  newsletters: NewsletterItem[];
}
const RecentNewsletterCard = ({
  newsletters
}: RecentNewsletterCardProps) => {
  const statusBadge = (status: string) => {
    const statusClasses = {
      draft: 'bg-secondary-100 text-secondary-800',
      scheduled: 'bg-blue-100 text-blue-800',
      sent: 'bg-green-100 text-green-800',
      failed: 'bg-red-100 text-red-800'
    };
    return <span className={`px-2 py-1 text-xs rounded-full ${statusClasses[status as keyof typeof statusClasses]}`} data-id="element-21">
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>;
  };
  return <div className="card" data-id="element-22">
      <div className="flex items-center justify-between mb-4" data-id="element-23">
        <h3 className="text-lg font-semibold text-secondary-900" data-id="element-24">
          Recent Newsletters
        </h3>
        <Link to="/newsletters" className="text-sm text-primary-600 hover:text-primary-700" data-id="element-25">
          View all
        </Link>
      </div>
      <div className="space-y-4" data-id="element-26">
        {newsletters.map(newsletter => <div key={newsletter.id} className="flex items-center justify-between p-3 bg-secondary-50 rounded-md" data-id="element-27">
            <div data-id="element-28">
              <h4 className="font-medium text-secondary-900" data-id="element-29">
                {newsletter.title}
              </h4>
              <p className="text-sm text-secondary-500" data-id="element-30">
                {newsletter.template} • {newsletter.sentDate}
              </p>
              <div className="flex items-center mt-1 space-x-2" data-id="element-31">
                {statusBadge(newsletter.status)}
                <span className="text-xs text-secondary-500" data-id="element-32">
                  {newsletter.recipients} recipients
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-2" data-id="element-33">
              <Link to={`/newsletters/edit/${newsletter.id}`} className="p-1 rounded-md text-secondary-500 hover:bg-white" data-id="element-34">
                <ExternalLinkIcon size={18} data-id="element-35" />
              </Link>
              <button className="p-1 rounded-md text-secondary-500 hover:bg-white" data-id="element-36">
                <MoreHorizontalIcon size={18} data-id="element-37" />
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};
export default RecentNewsletterCard;